import React from 'react';
import type { Project } from '../../models/projects/project';
import { STATUS } from '../../models/projects/project';
import {
  achievementRate,
  isOpened,
} from '../../models/projects/projectProgress';

interface Props {
  project: Project;
}

export default function CardPercentage(props: Props) {
  const { project } = props;

  if (
    (project.status === STATUS.inProgress && isOpened(project)) ||
    project.status === STATUS.succeeded ||
    project.status === STATUS.executed
  ) {
    const percentage = achievementRate(project);

    return (
      <div className="percentage">
        <span className="title">目標達成率</span>
        <span className="value">{percentage}%</span>
      </div>
    );
  } else {
    return <div />;
  }
}
